import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Alert, Box, Button, Snackbar, TextField, Menu } from "@mui/material";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { BLACK, GREY, WHITE } from "../../store/colorCode";
import BigTooltip from "../common/BigTooltip";
import image1 from "../common/images/image1.jpg";
import image2 from "../common/images/image2.jpeg";
import image3 from "../common/images/image3.jpeg";
import image4 from "../common/images/image4.jpg";
import { Link } from "react-router-dom";
import ShareIcon from "@mui/icons-material/Share";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import XIcon from "@mui/icons-material/X";
import { languageCode } from "../../store/languageData";
import { capitalize } from "../common/utility";
import axios from "axios";
import * as actions from "../../store/actions";
import { API } from "../../store/api";
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
  TwitterShareButton,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";
const Heading = styled("h3")(({ theme }) => ({
  position: "absolute",
  top: "calc(30%)",
  color: WHITE,
  fontWeight: 600,
  fontSize: "1.5rem",
  textTransform: "uppercase",
  textShadow: "1px 1px 2px " + BLACK,
  background: BLACK + "96",
  borderRadius: 10,
  padding: "10px 15px",
  [theme.breakpoints.up("md")]: {
    top: "calc(25%)",
  },
  [theme.breakpoints.down("md")]: {
    top: "calc(24%)",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.1rem",
  },
}));

const StyledLink = styled(Link)(() => ({
  color: WHITE,
  marginTop: 5,
  padding: 10,
  background: BLACK + "96",
  display: "inline-block",
  borderRadius: 10,
  "&:hover": {
    color: WHITE,
    textDecoration: "none",
    background: BLACK + "96",
    boxShadow: "0 0 2px " + BLACK,
  },
}));

const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: "80px",
  width: "85%",
  fontSize: "1.5rem",
  fontFamily: "Roboto Slab",
  textAlign: "center",
  transition: "opacity 0.35s ease-in-out",
  top: "calc(40%)",
  [theme.breakpoints.only("md")]: {
    width: "80%",
    fontSize: "1.2rem",
  },
  [theme.breakpoints.down("sm")]: {
    width: "90%",
    fontSize: "1.1rem",
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: "1rem",
  },
}));

const VerseText = styled(Box)(() => ({
  display: "-webkit-box",
  WebkitLineClamp: 4,
  textOverflow: "ellipsis",
  overflow: "hidden",
  WebkitBoxOrient: "vertical",
}));

const ContainerBox = styled(Box)(({ image }) => ({
  position: "relative",
  width: "100%",
  height: "65vh",
  minHeight: "300px",
  backgroundImage: `url(${image})`,
  border: "1px solid" + GREY,
  backgroundRepeat: "round",
  display: "flex",
  justifyContent: "center",
  transitionTimingFunction: "linear",
  transitionDelay: "1s",
}));

const VerseOfTheDayCard = ({
  setValue1,
  locale,
  versions,
  versionBooks,
  panel1,
  setBanner,
  setValue,
}) => {
  const theme = useTheme();
  const langCode = languageCode[locale].code;
  const [allVerseData, setAllVerseData] = useState();
  const [verseRef, setVerseRef] = useState({
    b: "psa",
    c: "119",
    v: "105",
  });
  const [sourceId, setSourceId] = useState("");
  const [verseObj, setVerseObj] = useState({});
  const [book, setBook] = useState("");
  const [shareAnchor, setShareAnchor] = React.useState(null);
  const [copyFeedback, setCopyFeedback] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alertType, setAlertType] = React.useState("");
  const open = Boolean(shareAnchor);
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [image1, image2, image3, image4];
  const versionCode = versions.find(
    (e) => e?.languageVersions[0]?.language?.code === langCode
  )?.languageVersions[0]?.version?.code;
  const fallBackVersion = versions.find(
    (e) => e?.languageVersions[0]?.language?.code === "eng"
  )?.languageVersions[0]?.version?.code;
  const verCheck = versions?.find(
    (e) => e?.languageVersions[0]?.language?.code === langCode
  )?.languageVersions;
  const version =
    langCode.toLowerCase() === "eng"
      ? `${langCode.toLowerCase()}-ULB`
      : versionCode !== undefined
      ? langCode.toLowerCase() + "-" + capitalize(versionCode)
      : `eng-${fallBackVersion}`;
  const verseOfTheDayRef = book
    ? `${book} ${verseObj.chapterNumber}:${verseObj.verseNumber} ` + version
    : "";
  const verseOfTheDayText = verseObj ? verseObj.verseContent?.text : "";
  const refBCVData = verseRef?.b + "." + verseRef?.c + "." + verseRef?.v;
  const path = `${window.location.href}read?version=${version}&reference=${refBCVData}`;
  const textContent =
    verseOfTheDayRef + "\n" + verseOfTheDayText + "\n\n" + path;
  function openShareDialog(event) {
    setShareAnchor(event.currentTarget);
  }
  function closeShareDialog() {
    setShareAnchor(null);
  }
  const closeAlert = () => {
    setAlert(false);
  };
  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(textContent);
      setAlert(true);
      setCopyFeedback(t("clipBoardCopied"));
      setAlertType("success");
      closeShareDialog();
    } catch (err) {
      console.error("Unable to copy to clipboard.", err);
      setAlert(true);
      setCopyFeedback(t("clipBoardCopiedFailed"));
      setAlertType("error");
      closeShareDialog();
    }
  };
  useEffect(() => {
    if (process.env.REACT_APP_DAILY_VERSE) {
      const APIBASE = axios.create({
        baseURL: process.env.REACT_APP_DAILY_VERSE,
      });
      APIBASE.get("verseData.json").then(function (response) {
        setAllVerseData(response?.data);
      });
    }
  }, []);
  useEffect(() => {
    let newDate = new Date();
    const currentYear = newDate?.getFullYear();
    const currentMonth = newDate?.getMonth() + 1;
    const currentDay = newDate?.getDate();
    if (allVerseData) {
      setVerseRef(allVerseData[currentYear][currentMonth][currentDay]);
    }
  }, [allVerseData]);

  useEffect(() => {
    const bestVersion = versions
      .find((e) => e.languageVersions.some((lv) => lv.version.code === "ULB"))
      ?.languageVersions.find((lv) => capitalize(lv.version.code) === "ULB");
    if (langCode === "eng" && bestVersion) {
      setSourceId(bestVersion.sourceId);
    } else {
      const sourceId = versions.find(
        (e) => e?.languageVersions[0]?.language?.code === langCode
      )?.languageVersions[0]?.sourceId;
      setSourceId(sourceId);
    }
  }, [langCode, versions]);
  useEffect(() => {
    const books = versionBooks[langCode];
    if (verseObj?.bibleBookCode) {
      const book = books?.find((i) => i.book_code === verseObj.bibleBookCode);
      setBook(book?.short);
    }
  }, [langCode, verseObj.bibleBookCode, versionBooks]);
  useEffect(() => {
    if (sourceId && verseRef) {
      const book = verseRef ? verseRef?.b : "psa";
      const chapter = verseRef ? verseRef?.c : "119";
      const verse = verseRef ? verseRef?.v : "105";
      API.get(`bibles/${sourceId}/verses/${book}.${chapter}.${verse}`).then(
        (response) => {
          setVerseObj(response.data);
          setValue("verseObj", response.data);
        }
      );
    } else if (verCheck === undefined) {
      const engVersion = versions?.find((el) => el?.language === "english");
      setSourceId(engVersion?.languageVersions[0].sourceId);
    }
  }, [setValue, sourceId, verCheck, verseRef, versions]);

  const setURL = () => {
    if (
      versionBooks[panel1.version.split("-")[0]]
        .map((i) => {
          return i.book_code;
        })
        .includes(verseRef.b)
    ) {
      setValue1("bookCode", verseRef?.b);
      setValue1("chapter", verseRef?.c);
      setValue1("verseData", verseRef?.v);
      setBanner(false);
    } else {
      setBanner(true);
    }
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      setCurrentIndex(nextIndex);
    }, 10000);
    return () => clearTimeout(timerId);
  }, [currentIndex, images.length]);

  const descriptionText = verseObj.verseContent?.text;
  const shareUrl = `${window.location.href}read?version=${version}&reference=${refBCVData}`;
  return (
    <ContainerBox image={images[currentIndex]}>
      <Heading>
        {t("landingVerseHeading")}
        <BigTooltip title={t("shareVerseOfTheDayTooltip")} placement="right">
          <ShareIcon
            fontSize="small"
            onClick={openShareDialog}
            sx={{
              color: WHITE,
              cursor: "pointer",
              textShadow: "1px 1px 2px " + BLACK,
              marginTop: "-1px",
              marginLeft: "8px",
            }}
          />
        </BigTooltip>
        <Menu
          id="long-menu"
          anchorEl={shareAnchor}
          keepMounted
          open={open}
          onClose={closeShareDialog}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{
            "& .MuiMenu-paper": {
              maxHeight: "450px",
              marginTop: "6px",
              width: "420px",
              alignItems: "left",
              paddingLeft: "12px",
            },
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <TextField
              id="share-url"
              variant="outlined"
              size="small"
              value={textContent}
              sx={{
                width: "94%",
                margin: "7px",
                color: WHITE,
              }}
              multiline
              InputProps={{
                readOnly: true,
              }}
              onFocus={(e) => e.target.select()}
            />
            <Button
              sx={{
                textTransform: "capitalize",
                margin: "10px auto",
                color: BLACK,
                borderColor: BLACK,
                "&:hover": {
                  backgroundColor: BLACK + "0a",
                  border: "1px solid rgba(0, 0, 0, 0.23)",
                },
              }}
              variant="outlined"
              onClick={handleCopyClick}
              startIcon={<FileCopyOutlinedIcon />}
            >
              {t("copyToClipBoardBtn")}
            </Button>
            <Box display={"flex"} justifyContent={"center"}>
              <FacebookShareButton
                url={shareUrl}
                hashtag={`VachanOnline Verse of the Day - ${book} ${verseObj.chapterNumber}:${verseObj.verseNumber}`}
                style={{ margin: "0 5px" }}
              >
                <FacebookIcon size={32} round={true} />
              </FacebookShareButton>
              <WhatsappShareButton
                url={shareUrl}
                title={descriptionText}
                style={{ margin: "0 5px" }}
              >
                <WhatsappIcon size={32} round={true} />
              </WhatsappShareButton>
              <EmailShareButton
                url={shareUrl}
                body={descriptionText}
                style={{ margin: "0 5px" }}
              >
                <EmailIcon size={32} round={true} />
              </EmailShareButton>
              <TwitterShareButton
                url={shareUrl}
                title={descriptionText}
                style={{ margin: "0 5px" }}
              >
                <XIcon size={32} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton url={shareUrl} style={{ margin: "0 5px" }}>
                <LinkedinIcon size={32} round={true} />
              </LinkedinShareButton>
            </Box>
          </div>
        </Menu>
        <Snackbar
          open={alert}
          autoHideDuration={800}
          onClose={closeAlert}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            elevation={6}
            variant="filled"
            onClose={closeAlert}
            severity={alertType}
          >
            {copyFeedback}
          </Alert>
        </Snackbar>
      </Heading>
      <StyledBox>
        <BigTooltip
          title={t("landingVerseHeadingToolTip")}
          placement="bottom-end"
        >
          <StyledLink to={{ pathname: "/read" }} onClick={() => setURL()}>
            <VerseText>{verseObj ? verseObj.verseContent?.text : ""}</VerseText>
            <Box
              sx={{
                fontStyle: "italic",
                fontSize: "1rem",
                color: WHITE,
                [theme.breakpoints.down("xs")]: {
                  fontSize: "0.9rem",
                },
              }}
            >
              {book
                ? `${book} ${verseObj.chapterNumber}:${verseObj.verseNumber}`
                : ""}
            </Box>
          </StyledLink>
        </BigTooltip>
      </StyledBox>
    </ContainerBox>
  );
};
const mapStateToProps = (state) => {
  return {
    versions: state.local.versions,
    locale: state.local.locale,
    versionBooks: state.local.versionBooks,
    panel1: state.local.panel1,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setValue1: (name, value) =>
      dispatch({ type: actions.SETVALUE1, name: name, value: value }),
    setBanner: (value) => dispatch({ type: actions.SETBANNER, value: value }),
    setValue: (name, value) =>
      dispatch({ type: actions.SETVALUE, name: name, value: value }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(VerseOfTheDayCard);
